import { WsHandler } from '../ws/WsHandler'
import { store } from '../../core/store/store'
import { updateScalesReading } from '../../core/store/scalesReading/scalesReadingSlice'
import { WS_LAST_SCALES_READING } from '../constants'

let wsHandler: WsHandler | null = null

export function getScalesReadingWsHandler() {
  if (!wsHandler) {
    wsHandler = new WsHandler(WS_LAST_SCALES_READING)
  }
  const listenerSetWsStateOpen = async () => {
    store.dispatch(updateScalesReading({ isWsOpen: true }))
  }
  const listenerSetWsStateClosed = async () => {
    store.dispatch(updateScalesReading({ isWsOpen: false }))
  }
  wsHandler.addEventListener('open', listenerSetWsStateOpen)
  wsHandler.addEventListener('close', listenerSetWsStateClosed)
  wsHandler.addEventListener('error', listenerSetWsStateClosed)
  return wsHandler
}
